export default {
  hasAuth: false,
  router: {
    strategy: 'next'
  },
  brandUrl: '/',
  brandBar: [],
  menus: {
    topHeader: []
  }
};
